import { FormProvider } from 'react-hook-form';
import React, { createContext } from 'react';
import { z } from 'zod';
import { IUpdateVendorFormContainer } from '../interfaces';
import { FormSwitch } from '../components/FormSwitch';
import { useLogic } from '../hooks/useLogic';
import { UpdateVendorFooter } from '../components/UpdateVendorFooter';

export const FormCtx = createContext<{scheme: z.ZodObject<{}>}>({ scheme: z.object({}) });

export const UpdateVendorFormContainer = (props: IUpdateVendorFormContainer) => {
  const { onVendorDelete, onVendorSubmit, moveType, isLoadingDelete, initialBusinessName, isLoading, vendorData, formType, billId, isVendorUpdateMandatory, isEditMode, customSubmitTitle, isUpdateNameRequired } = props;
  const { formMethods, scheme } = useLogic({ moveType, formType, vendorData, initialBusinessName, isUpdateNameRequired, isVendorUpdateMandatory });

  return (
    <div className='flex flex-col absolute w-full h-full inset-0'>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <FormCtx.Provider value={{ scheme }}>
        <FormProvider {...formMethods}>
          <div className='pt-[4px] flex flex-col mx-auto max-w-[500px] overflow-auto no-scrollbar no-scrollbar::-webkit-scrollbar h-full gap-[6px] w-[385px] pb-[100px]'>
            <FormSwitch
              isUpdateNameRequired={isUpdateNameRequired}
              vendorData={vendorData}
              isVendorUpdateMandatory={isVendorUpdateMandatory}
              billId={billId || ''}
              formType={formType}
              formMethods={formMethods}
              moveType={moveType}
            />
          </div>
          <UpdateVendorFooter
            isVendorUpdateMandatory={!!isVendorUpdateMandatory || !!isUpdateNameRequired}
            formMethods={formMethods}
            formType={formType}
            moveType={moveType}
            isEditMode={!!isEditMode}
            supplierId={vendorData?.supplierId || ''}
            onVendorDelete={onVendorDelete}
            onVendorSubmit={onVendorSubmit}
            isLoading={isLoading}
            isLoadingDelete={isLoadingDelete}
            customSubmitTitle={customSubmitTitle}
          />

        </FormProvider>
      </FormCtx.Provider>
    </div>
  );
};
